/* Reveliane – comportamentos das secoes portadas do Replo (sem o runtime deles):
   carrossel ([data-replo-carousel]) com setas, pontos, miniaturas e arraste (dedo e mouse) com encaixe,
   colapsavel ([data-replo-collapsible]), marquee ([data-replo-marquee-root]),
   botao de compra ([data-reveliane-add]) que adiciona ao carrinho e abre o cart-drawer do Dawn, e a galeria sticky do hero. */
(function () {
  'use strict';
  if (window.RevelianeReplo) return;
  var TRANS = 'transform 400ms cubic-bezier(0.4, 0, 0.2, 1)';

  function toggleAtivo(el, on) {
    var cls = el.getAttribute('data-rv-active-class');
    el.classList.toggle('is-active', on);
    if (cls) cls.split(' ').forEach(function (c) { if (c) el.classList.toggle(c, on); });
    el.setAttribute('aria-current', on ? 'true' : 'false');
  }

  /* ---------- carrossel ---------- */
  function Carousel(root) {
    this.root = root;
    this.track = root.querySelector('[data-replo-part="slide-track"]');
    this.area = root.querySelector('[data-replo-part="slides"]') || this.track;
    this.all = this.track ? Array.from(this.track.children).filter(function (s) { return s.getAttribute('data-replo-part') === 'slide'; }) : [];
    if (!this.track || this.all.length === 0) return;
    this.index = 0;
    this.unique = parseInt(root.getAttribute('data-rv-unique'), 10) || 0;   /* n de slides reais (o resto sao clones) */
    this.dots = Array.from(root.querySelectorAll('[data-replo-dot]'));
    this.thumbs = Array.from(root.querySelectorAll('[data-replo-thumb]'));
    this.prev = root.querySelector('[data-direction="previous"]');
    this.next = root.querySelector('[data-direction="next"]');
    var self = this;
    this.track.style.transition = TRANS;
    if (this.prev) this.prev.addEventListener('click', function (e) { e.preventDefault(); self.go(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function (e) { e.preventDefault(); self.go(self.index + 1); });
    this.dots.forEach(function (d, i) {
      d.addEventListener('click', function () { self.go(self.unique ? i : Math.round(i * self.perPage())); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); d.click(); } });
    });
    this.thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { self.go(i); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.go(i); } });
    });
    this.drag();
    window.addEventListener('resize', function () { self.go(self.index, true, true); });
    this.go(0, true);
  }
  /* slides visiveis (clones escondidos por CSS no mobile ficam de fora) */
  Carousel.prototype.slides = function () {
    return this.all.filter(function (s) { return s.offsetParent !== null; });
  };
  Carousel.prototype.perPage = function () {
    var v = parseFloat(getComputedStyle(this.track).getPropertyValue('--replo-carousel-slides-per-page'));
    return v > 0 ? v : 1;
  };
  /* distancia entre o inicio de um slide e o do seguinte (largura + gap), medida no DOM */
  Carousel.prototype.step = function () {
    var s = this.slides();
    if (s.length < 2) return s.length ? s[0].getBoundingClientRect().width : 0;
    return s[1].getBoundingClientRect().left - s[0].getBoundingClientRect().left;
  };
  /* deslocamento maximo: o ultimo slide termina rente a borda direita da area (mesma margem do primeiro) */
  Carousel.prototype.maxOffset = function () {
    var s = this.slides();
    if (!s.length) return 0;
    var a = s[0].getBoundingClientRect(), z = s[s.length - 1].getBoundingClientRect();
    return Math.max(0, (z.right - a.left) - this.area.getBoundingClientRect().width);
  };
  Carousel.prototype.offset = function (i) { return Math.min(i * this.step(), this.maxOffset()); };
  Carousel.prototype.max = function () {
    var m = Math.max(0, Math.ceil(this.slides().length - this.perPage() - 1e-6));
    if (this.unique) m = Math.min(m, this.unique - 1);
    return m;
  };
  Carousel.prototype.nearest = function (off) {
    var max = this.max(), best = 0, bd = Infinity;
    for (var i = 0; i <= max; i++) { var d = Math.abs(this.offset(i) - off); if (d < bd) { bd = d; best = i; } }
    return best;
  };
  Carousel.prototype.marca = function (i) {
    var pp = this.perPage();
    var ativo = this.unique ? (i % this.unique) : Math.round(i / pp);
    this.dots.forEach(function (d, k) { toggleAtivo(d, k === ativo); });
    this.thumbs.forEach(function (t, k) { toggleAtivo(t, k === i); });
  };
  /* go(i): setas/pontos dao a volta (loop); clamp=true (arraste, resize) para nos extremos */
  Carousel.prototype.go = function (i, silent, clamp) {
    var max = this.max();
    if (clamp) i = Math.max(0, Math.min(max, i));
    else { if (i < 0) i = max; if (i > max) i = 0; }
    this.index = i;
    var vis = this.slides();
    if (!vis.length) return;
    if (silent) this.track.style.transition = 'none';
    this.track.style.transform = 'translate3d(' + (-this.offset(i)) + 'px, 0, 0)';
    if (silent) { void this.track.offsetWidth; this.track.style.transition = TRANS; }
    var pp = this.perPage();
    this.all.forEach(function (s) {
      var k = vis.indexOf(s);
      var on = k >= i && k < i + pp;
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (k === i) s.setAttribute('data-is-active', 'true'); else s.removeAttribute('data-is-active');
    });
    this.marca(i);
    this.root.dispatchEvent(new CustomEvent('reveliane:slide', { detail: { index: i } }));
  };
  /* arraste com dedo ou mouse: o trilho acompanha, o ponto ativo atualiza na hora e no fim encaixa no card mais proximo */
  Carousel.prototype.drag = function () {
    var self = this, area = this.area, x0 = 0, y0 = 0, t0 = 0, base = 0, id = null, ativo = false, movendo = false;
    area.addEventListener('dragstart', function (e) { e.preventDefault(); });
    area.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('[data-direction], [data-replo-dot], [data-replo-thumb], button, input, select, textarea')) return;
      ativo = true; movendo = false; id = e.pointerId;
      x0 = e.clientX; y0 = e.clientY; t0 = e.timeStamp;
      base = self.offset(self.index);
    });
    area.addEventListener('pointermove', function (e) {
      if (!ativo) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!movendo) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;   /* vertical = rolagem normal da pagina */
        movendo = true;
        try { area.setPointerCapture(id); } catch (err) { /* ignora */ }
        self.track.style.transition = 'none';
        area.classList.add('rv-dragging');
      }
      e.preventDefault();
      var max = self.maxOffset(), off = base - dx;
      if (off < 0) off = off * 0.35; else if (off > max) off = max + (off - max) * 0.35;   /* resistencia nos extremos */
      self.track.style.transform = 'translate3d(' + (-off) + 'px, 0, 0)';
      self.marca(self.nearest(off));
    });
    function fim(e) {
      if (!ativo) return;
      ativo = false;
      if (!movendo) return;
      var dx = e.clientX - x0, dt = Math.max(1, e.timeStamp - t0), v = Math.abs(dx) / dt, step = self.step() || 1;
      var alvo = self.index;
      if (Math.abs(dx) >= step) alvo = self.nearest(base - dx);                       /* arrastou mais de um card */
      else if (Math.abs(dx) > step * 0.2 || v > 0.5) alvo = self.index + (dx < 0 ? 1 : -1);  /* um card na direcao do gesto */
      area.classList.remove('rv-dragging');
      self.track.style.transition = TRANS;
      self.go(alvo, false, true);
      setTimeout(function () { movendo = false; }, 0);
    }
    area.addEventListener('pointerup', fim);
    area.addEventListener('pointercancel', fim);
    area.addEventListener('click', function (e) { if (movendo) { e.preventDefault(); e.stopPropagation(); } }, true);
  };

  /* ---------- colapsavel (mesmo comportamento do Radix usado pelo Replo) ---------- */
  var PLUS = 'M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4';
  var MINUS = 'M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8';
  function Collapsible(root) {
    var trig = root.querySelector('[role="button"]');
    var content = root.querySelector('.replo-animated');
    if (!trig || !content) return;
    var path = trig.querySelector('svg path');
    function set(open, anim) {
      root.setAttribute('data-state', open ? 'open' : 'closed');
      trig.setAttribute('aria-expanded', open ? 'true' : 'false');
      trig.classList.toggle('is-open', open);
      if (path) path.setAttribute('d', open ? MINUS : PLUS);
      if (open) {
        content.hidden = false;
        content.style.setProperty('--radix-collapsible-content-height', content.scrollHeight + 'px');
        content.setAttribute('data-state', 'open');
      } else if (anim) {
        content.style.setProperty('--radix-collapsible-content-height', content.scrollHeight + 'px');
        content.setAttribute('data-state', 'closed');
        setTimeout(function () { if (root.getAttribute('data-state') === 'closed') content.hidden = true; }, 200);
      } else {
        content.hidden = true;
        content.setAttribute('data-state', 'closed');
      }
    }
    trig.setAttribute('tabindex', '0');
    trig.addEventListener('click', function () { set(root.getAttribute('data-state') !== 'open', true); });
    trig.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trig.click(); } });
    set(false, false);
  }

  /* ---------- marquee ---------- */
  function Marquee(root) {
    var track = root.querySelector('[data-replo-marquee-track]');
    if (!track) return;
    function medir() {
      var grupos = track.children.length || 1;
      track.style.setProperty('--replo-marquee-width', track.scrollWidth + 'px');
      track.style.setProperty('--replo-marquee-repetitions', String(grupos));
    }
    medir();
    window.addEventListener('resize', medir);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(medir);
    track.style.animation = (root.getAttribute('data-duration') || '20s') + ' linear infinite replo-marquee';
  }

  /* ---------- compra: adiciona ao carrinho e abre o drawer do Dawn ---------- */
  function Comprar(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var formId = btn.getAttribute('data-reveliane-add');
      var form = document.getElementById(formId);
      if (!form || btn.getAttribute('aria-busy') === 'true') return;
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { alert(res.description || res.message || 'Fehler'); return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = '/cart';
          }
          document.dispatchEvent(new CustomEvent('reveliane:added', { detail: res }));
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- galeria sticky do hero: top = altura do cabecalho visivel + 16px (cabe no viewport) ---------- */
  function StickyGaleria(col) {
    var raf = null;
    function calc() {
      raf = null;
      var header = document.querySelector('.section-header');
      var escondido = !!document.querySelector('.shopify-section-header-hidden');
      var hh = header && !escondido ? header.getBoundingClientRect().height : 0;
      /* nunca por baixo do cabecalho visivel; com o cabecalho recolhido (rolagem para baixo) fica a 16px do topo */
      var top = hh + 16;
      document.documentElement.style.setProperty('--rv-sticky-top', Math.round(top) + 'px');
    }
    function agenda() { if (raf === null) raf = requestAnimationFrame(calc); }
    window.addEventListener('scroll', agenda, { passive: true });
    window.addEventListener('resize', agenda);
    calc();
    setTimeout(calc, 800);
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-replo-carousel]').forEach(function (c) { if (!c.__rv) c.__rv = new Carousel(c); });
    scope.querySelectorAll('[data-replo-collapsible]').forEach(function (c) { if (!c.__rv) { c.__rv = true; Collapsible(c); } });
    scope.querySelectorAll('[data-replo-marquee-root]').forEach(function (m) { if (!m.__rv) { m.__rv = true; Marquee(m); } });
    scope.querySelectorAll('[data-reveliane-add]').forEach(function (b) { if (!b.__rv) { b.__rv = true; Comprar(b); } });
    scope.querySelectorAll('.rv-reveliane-hero .r-2rp3hh').forEach(function (g) { if (!g.__rv) { g.__rv = true; StickyGaleria(g); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.RevelianeReplo = { init: init, Carousel: Carousel };
})();
